import React from 'react'
import { Feedback } from 'util/constants'
import PostCommentsTabs from 'components/Posts/display/PostCommentsTabs';

interface Props {
    feedback: Feedback
}

const FeedbackProfileTabs = ({ feedback }: Props) => {
    return (
        <PostCommentsTabs kind="feedback" entityId={feedback.id} entityTitle={feedback.title} />
    )
}

export default FeedbackProfileTabs
